import ApexCharts from "apexcharts";

let context = [];

export function buildRegPlot(
  plotContainer,
  data,
  beta,
  isDark,
  derivedAlleleFreq,
  regIsFullRange,
  observedLabel = "Observed",
  glmmLabel = "Model Prediction"
) {
  data.sort((x, y) => y.date_center - x.date_center);
  data = data.filter((item) => {
    return item.date_center < 11000;
  });
  context.length = 0;
  data.forEach((item) => {
    context.push(
      '<div class="tooltip-apex">' +
        `<span><b style="color: ${isDark ? "#fff" : "#293352"}">Date </b>` +
        item.date_center.toFixed(0) +
        `<br/><span><b style="color: #4E84C4">${observedLabel} </b> ` +
        item.af.toFixed(2) +
        " [" +
        item.af_low.toFixed(2) +
        " , " +
        item.af_up.toFixed(2) +
        "]" +
        `</span><br/><span><b style="color: #D16103">${glmmLabel} </b> ` +
        item.pt.toFixed(2) +
        " [" +
        item.pt_low.toFixed(2) +
        " , " +
        item.pt_up.toFixed(2) +
        "]</span></div>"
    );
  });
  let options = getOptions(
    data,
    isDark,
    observedLabel,
    glmmLabel,
    derivedAlleleFreq,
    regIsFullRange
  );
  let chart = new ApexCharts(plotContainer, options);
  chart.render();
  return chart;
}

function getOptions(
  data,
  isDark,
  observedLabel,
  glmmLabel,
  derivedAlleleFreq,
  regIsFullRange
) {
  // let base_af = -data.reduce((min, val) => Math.floor(Math.min(min, val.af_low)), Infinity);
  // let base_pt = -data.reduce((min, val) => Math.floor(Math.min(min, val.pt_low)), Infinity);
  let yRange = null;
  if (regIsFullRange) {
    yRange = [0, 1];
  } else {
    let minY = Math.min(
      derivedAlleleFreq[0].DAF_low,
      derivedAlleleFreq[1].DAF_low,
      derivedAlleleFreq[2].DAF_low
    );
    let maxY = Math.max(
      derivedAlleleFreq[0].DAF_up,
      derivedAlleleFreq[1].DAF_up,
      derivedAlleleFreq[2].DAF_up
    );
    data.forEach((item) => {
      minY = Math.min(minY, item.pt_low, item.af_low);
      maxY = Math.max(maxY, item.pt_up, item.af_up);
    });
    yRange = [Math.max(minY, 0), maxY];
  }
  return {
    chart: {
      height: 430,
      width: 570,
      type: "rangeArea",
      zoom: {
        type: "xy",
        autoScaleYaxis: false,
        zoomedArea: {
          fill: {
            color: "rgb(165, 28, 48)",
            opacity: 0.25,
          },
          stroke: {
            color: "rgb(165, 28, 48)",
            opacity: 0,
            width: 1,
          },
        },
      },
      animations: {
        enabled: false,
      },
      foreColor: isDark ? "#fff" : "#000",
      toolbar: {
        show: true,
        offsetX: -5,
        offsetY: 10,
        tools: {
          download: false,
          selection: false,
          zoom: true,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
          customIcons: [],
        },
        autoSelected: "zoom",
      },
    },
    colors: [
      "#4E84C4",
      "#D16103",
      "#4E84C4",
      "#D16103",
      "#fa3c6c",
      "#3fb543",
      "#e8bd10",
      "#fa3c6c",
      "#3fb543",
      "#e8bd10",
    ],
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: [0.24, 0.24, 1, 1, 1, 1, 1, 1, 1, 1],
    },
    stroke: {
      curve: "straight",
      width: [0, 0, 2, 2, 2, 2, 2, 2, 2, 2],
    },
    title: {
      text: "",
      style: {
        fontFamily: "Ubuntu",
        fontSize: "19px",
        color: isDark ? "#fff" : "#000",
      },
      align: "center",
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return context[dataPointIndex];
      },
      theme: isDark ? "dark" : "light",
      onDatasetHover: false,
      intersect: true,
      shared: false,
    },
    grid: {
      show: false,
      padding: {
        top: 30,
        right: 45,
      },
    },
    xaxis: {
      type: "numeric",
      labels: {
        formatter: (val) => {
          if (val <= 0 && val >= -10000) {
            return `${-val.toFixed(0)}`;
          } else {
            return "";
          }
        },
        style: {
          colors: isDark ? "#fff" : "#000",
        },
      },
      axisBorder: {
        show: true,
        color: isDark ? "#fff" : "#000",
        offsetX: 0,
        offsetY: 0,
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: isDark ? "#fff" : "#000",
        width: 6,
        offsetX: 0,
        offsetY: 0,
      },
      min: -10000,
      max: 0,
      title: {
        text: "Date (Years Before Present)",
        style: {
          fontSize: "14px",
          fontFamily: "Ubuntu",
          fontWeight: "normal",
          color: isDark ? "#fff" : "#000",
        },
      },
      crosshairs: {
        enabled: true,
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toFixed(2),
        style: {
          colors: isDark ? "#fff" : "#000",
        },
      },
      min: Math.max(0, yRange[0] - 0.001),
      max: yRange[1] + 0.001,
      title: {
        text: "Derived Allele Frequency",
        style: {
          fontSize: "14px",
          fontFamily: "Ubuntu",
          fontWeight: "normal",
          color: isDark ? "#fff" : "#000",
        },
      },
      axisBorder: {
        show: true,
        color: isDark ? "#fff" : "#000",
        offsetX: -4,
        offsetY: 0,
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: isDark ? "#fff" : "#000",
        width: 6,
        offsetX: 4,
        offsetY: 0,
      },
    },
    markers: {
      shape: "circle",
      size: [3, 3, 3, 3, 3, 3, 3, 6, 6, 6],
      fillOpacity: [0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
      strokeColors: "#ddd",
      strokeWidth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    legend: {
      show: false,
    },
    series: [
      {
        name: `${observedLabel} Range`,
        data: data.map((item) => ({
          x: -item.date_center,
          y: [item.af_low, item.af_up],
        })),
        type: "rangeArea",
      },
      {
        name: `${glmmLabel} Range`,
        data: data.map((item) => ({
          x: -item.date_center,
          y: [item.pt_low, item.pt_up],
        })),
        type: "rangeArea",
      },
      {
        name: observedLabel,
        data: data.map((item) => ({ x: -item.date_center, y: item.af })),
        type: "line",
      },
      {
        name: glmmLabel,
        data: data.map((item) => ({ x: -item.date_center, y: item.pt })),
        type: "line",
      },
      {
        name: derivedAlleleFreq[0].pop,
        data: [
          {
            x: -derivedAlleleFreq[0].Date - 0.5,
            y: [derivedAlleleFreq[0].DAF_low, derivedAlleleFreq[0].DAF_up],
          },
          {
            x: -derivedAlleleFreq[0].Date + 0.5,
            y: [derivedAlleleFreq[0].DAF_low, derivedAlleleFreq[0].DAF_up],
          },
        ],
        type: "rangeArea",
      },
      {
        name: derivedAlleleFreq[1].pop,
        data: [
          {
            x: -derivedAlleleFreq[1].Date - 0.5,
            y: [derivedAlleleFreq[1].DAF_low, derivedAlleleFreq[1].DAF_up],
          },
          {
            x: -derivedAlleleFreq[1].Date + 0.5,
            y: [derivedAlleleFreq[1].DAF_low, derivedAlleleFreq[1].DAF_up],
          },
        ],
        type: "rangeArea",
      },
      {
        name: derivedAlleleFreq[2].pop,
        data: [
          {
            x: -derivedAlleleFreq[2].Date - 0.5,
            y: [derivedAlleleFreq[2].DAF_low, derivedAlleleFreq[2].DAF_up],
          },
          {
            x: -derivedAlleleFreq[2].Date + 0.5,
            y: [derivedAlleleFreq[2].DAF_low, derivedAlleleFreq[2].DAF_up],
          },
        ],
        type: "rangeArea",
      },
      {
        name: derivedAlleleFreq[0].pop + " Range",
        data: [
          {
            x: -derivedAlleleFreq[0].Date,
            y: derivedAlleleFreq[0].DAF,
          },
        ],
        type: "scatter",
      },
      {
        name: derivedAlleleFreq[1].pop + " Range",
        data: [
          {
            x: -derivedAlleleFreq[1].Date,
            y: derivedAlleleFreq[1].DAF,
          },
        ],
        type: "scatter",
      },
      {
        name: derivedAlleleFreq[2].pop + " Range",
        data: [
          {
            x: -derivedAlleleFreq[2].Date,
            y: derivedAlleleFreq[2].DAF,
          },
        ],
        type: "scatter",
      },
    ],
  };
}
